import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { insertMessages } from "./messagesAPI";
import swal from 'sweetalert';
export interface MessageState {
  newmessages: Array<any>;
  status: "idle" | "loading" | "failed";
}

const initialState: MessageState = {
  newmessages: [],
  status: "idle",
};

export const InsertMessages = createAsyncThunk(
  "message/insertMessages",
  async (data:any) => {
    const response = await insertMessages(data);
    return response;
  }
);

export const newmessageSlice = createSlice({
  name: "message",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(InsertMessages.pending, (state) => {
        state.status = "loading";
      })
      .addCase(InsertMessages.rejected, (state, action) => {
        state.status = "failed";
        swal("Something went wrong!",  "error");
      })
      .addCase(InsertMessages.fulfilled, (state, action) => {
        state.status = "idle";
        state.newmessages =  action.payload;
        swal("Message Saved success!",  "success");
      });
  },
});

export const {} = newmessageSlice.actions;

export const selectMessages = (state: RootState) => {
  return state.Newmessage.newmessages;
};

export default newmessageSlice.reducer;
